import { render, staticRenderFns } from "./addJob.vue?vue&type=template&id=5885f3b8&"
import script from "./addJob.vue?vue&type=script&lang=js&"
export * from "./addJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports